module.exports = __webpack_public_path__ + "static/media/custom_integration.2c3c4cce.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/views/docs/img/custom_integration.png
// module id = 974
// module chunks = 0